export default "https://cdn-static.gokick.com/assets/4215e61f258b66d5599ee2c3a2c4c86e46d29fa2/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";